import { fetchAuthSession } from 'aws-amplify/auth';

export default async function currentUserToken() {
    const session = await fetchAuthSession();
    return session.tokens.idToken;
}
